/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { IUserService } from "@common/service/user.service";
import { ISubjectService } from "@common/service/subject.service";
import { IConfigService } from "@common/service/config.service";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { CacheService } from "@common/service/cache.service";
import { Util } from "@common/util";
import { TeamPermissionService } from "@common/service/teamPermission.service";
import { Subject, TeamTypeEnum } from "@common/model/subject";
import { User } from "@common/model/user";
import { FormUser } from "@common/model/formUser";
import { OrgNameEnum } from "@common/model/organization";
import { APIService } from "@common/api/api.service";
import { MODULES } from "@common/model/constants";

export interface IMugshot {
    getIsFormer(): boolean;
    onMugshotClick: Function;
    onMugshotImageError(): void;
    onActionBadgeClick: Function;
    init(): void;
    mugshotType: string;
    subjectType: string;
    forceUpdate: boolean;
    person: any;
    personId: number;
    tooltipPrefix: string;
    getId: Function;
    getMugshotImage: Function;
    getIsCoCaptain: Function;
    getInitials: Function;
    getFullName: Function;
}

class MugshotController implements IMugshot {
    person: any;
    personId: number;
    mugshotFunc: Function;
    mugshotType: string;
    subjectType: string;
    initials: string;
    fullName: string;

    forcedImage: string;
    forcedBgColor: string;

    forceUpdate: boolean;
    forceInitials: boolean;

    noImg: boolean;
    couldntFind: boolean;

    isFrozen: boolean;
    isFormer: boolean;
    isCaptain: boolean;
    isCoCaptain: boolean;
    subjectTypeId: string;
    tooltipPrefix: string;
    tooltipPlacement: string;
    mgshtTooltipClass: string;
    mgshtTooltipDisable: boolean;
    orgShortName: string;

    hideStatus: boolean;
    tempPhoto: string;
    where: string;
    image: string;
    errImg: string;
    bgColor: string;
    enableCrProfile: boolean;
    displayRoleBadge: boolean;
    displayActionBadge: boolean;
    actionBadgeFunc: Function;
    actionBadgeConfig: any;
    enterpriseBranding: boolean;
    stdDetails;
    isRgnTenTeam: boolean;
    userActive: boolean;
    stdLoading: boolean;

    static $inject = [
        "$timeout",
        "$location",
        "UserService",
        "SubjectService",
        "ConfigService",
        "$uibModal",
        "APIService",
        "TeamPermissionService",
        "ApiAdapterService",
        "CacheService",
        "imgEnv"
    ];
    constructor(
        private $timeout: angular.ITimeoutService,
        private $location: angular.ILocationService,
        private $_user: IUserService,
        private $_subject: ISubjectService,
        private $_config: IConfigService,
        private $uibModal: angular.ui.bootstrap.IModalService,
        private APIService: APIService,
        private $_teamPerm: TeamPermissionService,
        private $_api: JavaApiAdapterService,
        private $_cache: CacheService,
        private imgEnv: string
    ) {
        this.forceUpdate = false;
        this.errImg = this.$_config.get("defaultMugshot", "");
    }

    openCrProfile(): void {
        this.$uibModal
            .open({
                templateUrl:
                    "app/common/popup/crProfilePopup/crProfilePopup.html",
                controller: "CrProfilePopupController",
                controllerAs: "crProfilePopupVm",
                windowClass: "cr-profile-modal",
                resolve: {
                    subject: () => this.person,
                },
            })
            .result.then(
                function (s) {
                    //do something
                },
                function (e) {
                    console.log(e);
                }
            );
    }

    onMugshotClick($event): void {
        let docsCnt = $($event.target).parents("#document-list");
        if (
            docsCnt.length == 0 ||
            !docsCnt.attr("class").includes("multi-select-mode")
        ) {
            if (!!this.mugshotFunc) {
                this.mugshotFunc(this, $event);
            }
            if (this.enableCrProfile == true) {
                this.openCrProfile();
            }
        }
    }

    onActionBadgeClick($event): void {
        if (!!this.actionBadgeFunc) {
            this.actionBadgeFunc({ evnt: $event });
        }
    }

    onMugshotImageError = (): void => {
        this.noImg = true;
        let urls = this.image.split("?");
        if (urls.length > 0) {
            let isMugshot = urls[0].indexOf(this.imgEnv + "/mugshots/") != -1;
            let splitUrl = urls[0].split("/");
            if (splitUrl.length > 0) {
                let imageName = splitUrl[splitUrl.length - 1];
                let path = isMugshot ? "mugshots" : "thumbnails";
                let image = this.APIService.getImageUrl(path, imageName);
                if (image != "") {
                    this.noImg = false;
                    this.image = image;
                }
            }
        }
    };

    getMugshotImage = (): string => {
        return (
            ((this.mugshotType == "fu" ? this.person.user : this.person) || {})
                .photo || null
        );
    };

    getActionBadgeClasses = () => {
        let styles = {
            "background-color": !!this.actionBadgeConfig.bgColor
                ? this.actionBadgeConfig.bgColor
                : Util.COLORS.ecvBlue,
            width: !!this.actionBadgeConfig.size
                ? this.actionBadgeConfig.size + "px"
                : "14px",
            height: !!this.actionBadgeConfig.size
                ? this.actionBadgeConfig.size + "px"
                : "14px",
        };
        return styles;
    };

    getId = (): number => {
        if (this.mugshotType == "cr") {
            return this.person.subjectId;
        } else {
            return this.person.userId;
        }
    };

    getBgColor = (): string => {
        return (
            ((this.mugshotType == "fu" ? this.person.user : this.person) || {})
                .bgColor || "#0091EA"
        );
    };

    getInitials = (): string => {
        let fni = this.getFirstName()[0] || "#";
        let lni = this.getLastName()[0] || "#";
        return (fni + lni).toUpperCase();
    };

    getFirstName = (): string => {
        if (this.mugshotType == "fu" && !!this.person.user)
            return this.person.user.firstName || "";
        return this.person.firstName || "";
    };

    getLastName = (): string => {
        if (this.mugshotType == "fu" && !!this.person.user)
            return this.person.user.lastName || "";
        return this.person.lastName || "";
    };

    getFullName = (): string => {
        // this.person.fullName=(this.mugshotType == 'fu' ? this.person.user : this.person).fullName;
        // if(!this.person.fullName){
        //   this.person.fullName = this.getFirstName() +" "+ this.getLastName();
        // // }
        // return this.person.fullName || null;

        if (this.mugshotType == "fu" && !!this.person.user)
            return (
                this.person.user.fullName ||
                this.getFirstName() + " " + this.getLastName() ||
                ""
            );
        return (
            this.person.fullName ||
            this.getFirstName() + " " + this.getLastName() ||
            ""
        );
    };

    isActivePerson = (): boolean => {
        return !this.getIsFormer() && !this.getIsFrozen();
    };

    isInvitedUser = (): boolean => {
        return (
            this.mugshotType != "cr" &&
            !this.userActive &&
            !((this.mugshotType == "fu" ? this.person.user : this.person) || {})
                .isActive
        );
    };

    getProviderId = (): string => {
        return (
            (this.mugshotType == "fu" ? this.person.user : this.person) || {}
        ).providerIdentity;
    };

    getOrgLogo = () => {
        this.orgShortName = null;
        if (!!this.enterpriseBranding) {
            if (this.mugshotType == "tm") {
                this.orgShortName = (this.person || {}).organizationShortName;
            } else if (this.mugshotType == "cr") {
                if (!!this.person) {
                    this.orgShortName = this.$_teamPerm.isModuleAllowedForTeam(
                        this.person,
                        MODULES.LOGO
                    )
                        ? this.person.teamOrgShortName
                        : null;
                }
            }
        }
    };

    getIsFormer = (): boolean => {
        return (
            (this.mugshotType == "fu" ? this.person.user : this.person) || {}
        ).isFormerTeamMember;
    };

    getIsFrozen = (): boolean => {
        return (
            (this.mugshotType == "fu" ? this.person.user : this.person) || {}
        ).isFrozen;
    };

    getIsCaptain = (): boolean => {
        if (this.mugshotType == "tm") {
            return !!(this.person || {}).captain ? true : false;
        } else if (this.mugshotType == "fu" && !!this.person) {
            return !!(this.person.user || {}).captain ? true : false;
        } else {
            return false;
        }
    };

    getIsCoCaptain = (): boolean => {
        if (this.mugshotType == "tm") {
            return !!(this.person || {}).coCaptain ? true : false;
        } else if (this.mugshotType == "fu" && !!this.person) {
            return !!(this.person.user || {}).coCaptain ? true : false;
        } else {
            return false;
        }
    };

    getSubjectTypeId = (): string => {
        return (this.person || { subjectTypeId: "INDIVIDUAL" }).subjectTypeId;
    };

    fetchDetails = () => {
        if (
            this.mgshtTooltipClass == "team-details-tooltip" &&
            this.person.teamType == TeamTypeEnum.STUDENT &&
            !this.stdDetails
        ) {
            this.stdLoading = true;
            this.$_api
                .getCstmAttrForReport(
                    [this.person.subjectId],
                    ["studentId", "ssa", "grade", "center", "programType"],
                    this.$_cache.getPassword()
                )
                .then((subs) => {
                    this.stdDetails = subs[0].customAttributeObj;
                    if (this.stdDetails["ssa"]) {
                        this.stdDetails["schoolDisplay"] =
                            this.$_user.schools[this.stdDetails["ssa"]];
                    } else if (this.stdDetails["center"]) {
                        this.stdDetails["schoolDisplay"] =
                            this.$_user.schools[this.stdDetails["center"]];
                    } else if (this.stdDetails["school"]) {
                        this.stdDetails["schoolDisplay"] =
                            this.$_user.schools[this.stdDetails["school"]];
                    }
                    if (this.stdDetails["programTypeDisplay"]) {
                        this.stdDetails["gradeDisplay"] =
                            this.stdDetails["programTypeDisplay"];
                    }
                    this.stdLoading = false;
                });
        }
    };

    init(): void {
        this.couldntFind = false;
        this.mugshotType = this.mugshotType.toLowerCase();
        !!this.tooltipPlacement || (this.tooltipPlacement = "top");
        !!this.tooltipPrefix || (this.tooltipPlacement = null);
        !!this.hideStatus && (this.hideStatus = true);
        !!this.forceInitials && (this.forceInitials = true);
        this.noImg = !!this.noImg; // true if already exists and true, otherwise false
        if (!!this.displayRoleBadge) {
            //do nothing
        } else {
            this.displayRoleBadge = false;
        }
        // if (!!this.displayActionBadge) {
        //   this.hideStatus = true;
        // }

        if (!this.person) {
            if (this.mugshotType == "cr") {
                //empty Subject
                this.person = new Subject();
            } else if (this.mugshotType == "tm") {
                //empty User
                this.person = new User();
            } else if (this.mugshotType == "fu") {
                this.person = new FormUser({ user: new User() });
            }
        }

        this.getOrgLogo();
        this.initials = this.getInitials();
        this.fullName = this.getFullName();
        this.isFrozen = !!this.getIsFrozen();
        this.isFormer = !!this.getIsFormer();
        this.isCaptain = !!this.getIsCaptain();
        this.isCoCaptain = !!this.getIsCoCaptain();
        this.subjectTypeId = this.getSubjectTypeId();
        if (this.subjectType == "INDIVIDUAL") {
            this.subjectTypeId = "INDIVIDUAL";
        } else if (this.subjectType == "PROJECT") {
            this.subjectTypeId = "PROJECT";
        }
        this.bgColor = this.getBgColor();
        if (!!this.forcedBgColor) {
            this.bgColor = this.forcedBgColor;
        }

        if (this.forceUpdate == true) {
            this.tempPhoto =
                (this.mugshotType == "fu" ? this.person.user : this.person)
                    .tempPhoto || null;
        }

        let image =
            this.forcedImage || this.tempPhoto || this.getMugshotImage();
        if (image == null || image == undefined || image == "") {
            this.noImg = true;
        } else {
            this.noImg = false;
            this.image = image;
        }
        this.isRgnTenTeam =
            !!this.person.teamOrgShortName &&
            this.person.teamOrgShortName.toUpperCase() == OrgNameEnum.REGION_10;

        if (this.isInvitedUser() && !this.getProviderId()) {
            this.mgshtTooltipDisable = true;
        }
    }

    private printStatus() {
        console.log("Mushot Initializing:", this.where);
        console.log("- mugshot type:", this.mugshotType);
        console.log(
            "- mugshot person:",
            this.mugshotType == "fu" ? this.person.user : this.person
        );
        !!this.couldntFind && console.error("- COULD NOT FIND USER BY ID");
        !!this.personId && console.log("- mugshot personId:", this.personId);
        !!this.noImg && console.log("- mugshot noImg?: true");
        !this.noImg &&
            console.log(
                "- mugshot url:",
                (this.mugshotType == "fu"
                    ? this.person.user
                    : this.person
                ).getMugshotImage()
            );
        console.log("- mugshot forceInitials?:", !!this.forceInitials);
        console.log("- mugshot hideStatus:", !!this.hideStatus);
        console.log("- mugshot isFrozen:", !!this.isFrozen);
        console.log("- mugshot isFormer:", !!this.isFormer);
    }
}

function mugshot(): ng.IDirective {
    return {
        restrict: "E",
        templateUrl: "app/common/mugshot/mugshot.directive.html",
        replace: true,
        controller: MugshotController,
        controllerAs: "mugshotVm",
        scope: true,
        bindToController: {
            person: "=?person",
            mugshotFunc: "=?mugshotFunc",
            forceInitials: "@?forceInitials",
            forceUpdate: "=?forceUpdate",
            tooltipPlacement: "@?ecvTooltipPlacement",
            tooltipPrefix: "@?tooltipPrefix",
            hideStatus: "@?hideStatus",
            displayRoleBadge: "=?displayRoleBadge",
            mugshotType: "@mugshotType",
            forcedImage: "@?image",
            subjectType: "@?subjectType",
            where: "@?where",
            personId: "=?personId",
            enableCrProfile: "=?enableCrProfile",
            forcedBgColor: "=?forcedBgColor",
            displayActionBadge: "@?displayActionBadge",
            actionBadgeFunc: "&?actionBadgeFunc",
            actionBadgeConfig: "=?actionBadgeConfig",
            actionBadgeTooltip: "=?actionBadgeTooltip",
            displayConfirmTooltip: "=?displayConfirmTooltip",
            confirmTooltipMsg: "=?confirmTooltipMsg",
            enterpriseBranding: "=",
            mgshtTooltipClass: "@",
            mgshtTooltipDisable: "@",
            badgeTooltipDisable: "@",
            userActive: "=?",
        },
        link: (
            scope: ng.IScope,
            element: ng.IAugmentedJQuery,
            attributes: ng.IAttributes,
            controller: IMugshot
        ): void => {
            controller.init();
            scope.$watch(
                () => {
                    if (!controller.person) return null;
                    return controller.getId();
                },
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        controller.init();
                    }
                }
            );

            // if (controller.personId) {
            //     scope.$watch(() => {
            //         return controller.personId;
            //     }, (newVal, oldVal) => {
            //         if (newVal != oldVal) {
            //             controller.init();
            //         }
            //     });
            // }

            scope.$watch(
                () => {
                    return !!controller.person
                        ? controller.getMugshotImage()
                        : null;
                },
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        controller.init();
                    }
                }
            );

            scope.$watch(
                () => {
                    return !!controller.person
                        ? controller.getIsCoCaptain()
                        : null;
                },
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        controller.init();
                    }
                }
            );

            scope.$watch(
                () => {
                    return !!controller.person
                        ? controller.getIsFormer()
                        : null;
                },
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        controller.init();
                    }
                }
            );
            scope.$watch(
                () => {
                    return !!controller.person
                        ? controller.getInitials()
                        : null;
                },
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        controller.init();
                    }
                }
            );

            if (controller.forceUpdate) {
                scope.$watch(
                    () => {
                        return !!controller.person
                            ? controller.person.tempPhoto
                            : null;
                    },
                    (newVal, oldVal) => {
                        if (newVal != oldVal) {
                            controller.init();
                        }
                    }
                );
            }
        },
    };
}

angular.module("eCareVault.common.mugshot").directive("mugshot", mugshot);
